
import React from 'react';
import { TabButton } from '../../components/TabButton';
import { rootUseStyles } from '../../taskpane/fluent-style';
import ReportPhishingButton from '../common/report-phishing-button';

import ThreatDescriptions from './components/ThreatDescriptions';
import ThreatList from './components/ThreatList';
import { makeStyles } from '@fluentui/react-components';
import DeepScanResultContent from './components/DeepScanResultContent';

const useStyles = makeStyles({
  main: {
    flex: 1,
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  section2: {
    padding: "0px 15px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

});

export default function DeepScanResult() {
  return (
    <main className={`${rootUseStyles().root} ${useStyles().main}`}>
      <TabButton />
      <DeepScanResultContent />
    </main>
  )
}


